import Home from '@/components/common/Home.vue';

export const offerRoutes = {
  path: '/offer',
  component: Home,
  name: 'Offer',
  redirect: '/offer/top',
  meta: {
    title: 'Offer',
  },
  children: [
    {
      path: 'top',
      component: () => import('@/views/product/Ranking&search.vue'),
      meta: {
        title: 'Ranking search',
      },
    },
    {
      path: 'detail',
      component: () => import('@/views/offer/OfferDetail.vue'),
      meta: {
        title: 'Offer Detail',
      },
    },
    {
      path: 'offerLogAdv',
      component: () => import('@/views/offer/OfferlogAdv.vue'),
      meta: {
        title: 'OfferLogAdv',
      },
    },
    {
      path: 'smartLink',
      component: () => import('@/views/offer/OfferSmartLink.vue'),
      meta: {
        title: 'OfferSmartLink',
      },
    },
    {
      path: 'add',
      component: () => import('@/views/product/Add.vue'),
      meta: {
        title: 'Add',
      },
    },
  ],
};
